export const getFilenameAndExtension = (filename: string) => {
  if (!filename) {
    return [];
  }

  const split = filename.split('.');
  if (split.length <= 1) {
    return [filename, ''];
  }

  const filenameWithoutExtension = split.slice(0, -1).join('.');
  const fileExtension = split[split.length - 1];
  return [filenameWithoutExtension, fileExtension];
};

export const sanitizeFilePath = (path: string) => {
  return path.replace(/\/{2,}/g, '/');
};
